(() => {
  const root = document.querySelector('[data-promo-offer]');
  if (!root) return;

  const parseDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
  };

  const startsAt = parseDate(root.dataset.startsAt);
  const endsAt = parseDate(root.dataset.endsAt);
  const designMode = root.hasAttribute('data-design-mode');

  const isActive = () => {
    if (startsAt === undefined || endsAt === undefined) {
      console.warn('TEST:: Promo offer has an invalid start/end date', root.dataset.startsAt, root.dataset.endsAt);
      return false;
    }
    const now = Date.now();
    if (startsAt && now < startsAt.getTime()) return false;
    if (endsAt && now > endsAt.getTime()) return false;
    return true;
  };

  if (!designMode && !isActive()) return;

  root.hidden = false;

  const code = root.dataset.code;
  const codeNote = root.querySelector('.promo-offer__code');
  const storageKey = `promo-offer-applied:${code}`;
  const alreadyApplied = () => {
    try {
      return sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  };

  // /discount/CODE answers 200 even for unknown codes, so only network errors land here.
  // The note would otherwise still claim the code was applied.
  const showManualCode = () => {
    const fallback = root.dataset.codeFallback;
    if (codeNote && fallback) codeNote.textContent = fallback;
  };

  if (code && !designMode && !alreadyApplied()) {
    // Without a redirect, /discount/CODE lands on the homepage and fetch downloads all of it.
    fetch(`/discount/${encodeURIComponent(code)}?redirect=%2Fcart.js`, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        try {
          sessionStorage.setItem(storageKey, '1');
        } catch (error) {}
      })
      .catch((error) => {
        console.warn('TEST:: Promo code failed to apply', code, error);
        showManualCode();
      });
  }

  let variants = {};
  try {
    variants = JSON.parse(root.querySelector('[data-promo-offer-variants]').textContent);
  } catch (error) {
    console.warn('TEST:: Promo offer variant data unreadable', error);
  }

  const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);

  const currentVariantId = () => {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return new URLSearchParams(window.location.search).get('variant');
  };

  let expired = false;
  let lastVariantId = null;
  let featureLabel = null;
  let originalFeatureText = null;

  const renderPrice = (variantId) => {
    const option = document.querySelector('.rc_widget__option--subsave');
    if (!option) return;

    const prices = variants[variantId] || variants[Object.keys(variants)[0]];
    if (!prices) return;

    let priceEl = option.querySelector('.promo-offer__price');
    if (priceEl && priceEl.dataset.variantId === String(variantId)) return;

    if (!priceEl) {
      priceEl = document.createElement('span');
      priceEl.className = 'promo-offer__price';
      const selector = option.querySelector('.rc_widget__option__selector') || option.firstElementChild;
      if (selector) {
        selector.insertAdjacentElement('afterend', priceEl);
      } else {
        option.appendChild(priceEl);
      }
    }

    const note = (root.dataset.priceNote || '').replace('[sub_price]', prices.sub);
    priceEl.dataset.variantId = String(variantId);
    priceEl.innerHTML = `<s>${escapeHtml(prices.price)}</s> <strong>${escapeHtml(prices.first)}</strong> ${escapeHtml(note)}`;
    lastVariantId = String(variantId);
  };

  const renderFeature = () => {
    const text = root.dataset.featureText;
    if (!text) return;
    const label = document.querySelector('.rc-selling-plans .features-container .subscription-feature-item > div');
    if (!label || label.textContent === text) return;
    featureLabel = label;
    originalFeatureText = label.textContent;
    label.textContent = text;
  };

  const observer = new MutationObserver(() => {
    const option = document.querySelector('.rc_widget__option--subsave');
    if (option && !option.querySelector('.promo-offer__price')) {
      renderPrice(lastVariantId || currentVariantId());
    }
    renderFeature();
  });

  const onVariantChange = (event) => {
    const variant = event.detail && event.detail.variant;
    if (variant && variant.id) renderPrice(variant.id);
  };

  // A tab left open past the end time would otherwise keep showing a discount checkout no longer gives.
  const expire = () => {
    if (expired) return;
    expired = true;
    observer.disconnect();
    document.removeEventListener('variantChange', onVariantChange);
    root.hidden = true;
    document.querySelectorAll('.promo-offer__price').forEach((el) => el.remove());
    if (featureLabel && originalFeatureText !== null) featureLabel.textContent = originalFeatureText;
  };

  document.addEventListener('variantChange', onVariantChange);
  observer.observe(document.body, { childList: true, subtree: true });

  renderPrice(currentVariantId());
  renderFeature();

  const maxTimeout = 2147483647;
  if (!designMode && endsAt) {
    const msLeft = endsAt.getTime() - Date.now();
    if (msLeft <= maxTimeout) setTimeout(expire, Math.max(msLeft, 0));

    // Timers don't count down while the computer sleeps, so recheck when the tab is viewed again.
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && Date.now() > endsAt.getTime()) expire();
    });
  }
})();
